import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { UsersIcon, DocumentAddIcon, ClipboardListIcon, DocumentReportIcon, LogoutIcon } from '../UI/Icons';

// Simple UpdateIcon for Promotions
const UpdateIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
);

export default function Sidebar({ activeView, setActiveView, currentYear, setCurrentYear }) {

    const handleSignOut = async () => {
        if (window.confirm("¿Estás seguro de que quieres cerrar sesión?")) {
            try {
                await signOut(auth);
            } catch (error) {
                console.error("Error al cerrar sesión", error);
            }
        }
    };

    const menuItems = [
        { id: 'students', label: 'Estudiantes', icon: <UsersIcon /> },
        { id: 'achievements', label: 'Logros', icon: <DocumentAddIcon /> },
        { id: 'grades', label: 'Calificaciones', icon: <ClipboardListIcon /> },
        { id: 'bulletins', label: 'Boletines', icon: <DocumentReportIcon /> },
        { id: 'promotions', label: 'Promociones', icon: <UpdateIcon className="w-5 h-5" /> },
    ];

    // Generate upcoming years for selection (e.g., last 2 years + next 2 years)
    const years = [];
    const baseYear = new Date().getFullYear();
    for (let i = -1; i <= 2; i++) {
        years.push(baseYear + i);
    }

    return (
        <aside className="hidden md:flex flex-col w-72 h-screen p-4 sticky top-0">
            <div className="glass-card flex-grow rounded-2xl flex flex-col overflow-hidden animate-slide-up">
                {/* Header */}
                <div className="p-6 pb-2">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center text-white font-bold shadow-lg">
                            P
                        </div>
                        <h1 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary-700 to-secondary-700">
                            Preescolar
                        </h1>
                    </div>

                    {/* Year Selector */}
                    <div className="mb-4 px-1">
                        <label className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-1 block ml-1">Año Lectivo</label>
                        <select
                            value={currentYear}
                            onChange={(e) => setCurrentYear(Number(e.target.value))}
                            className="glass-input w-full py-2 px-3 rounded-lg text-sm font-bold text-slate-700 focus:ring-primary-400"
                        >
                            {years.map(y => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>

                    <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-2 ml-2">
                        Menú Principal
                    </p>
                </div>

                {/* Navigation */}
                <nav className="flex-1 px-4 space-y-2 overflow-y-auto custom-scrollbar">
                    {menuItems.map(item => {
                        const isActive = activeView === item.id;
                        return (
                            <button
                                key={item.id}
                                onClick={() => setActiveView(item.id)}
                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 group
                                    ${isActive
                                        ? 'bg-primary-600 text-white shadow-lg shadow-primary-500/30'
                                        : 'text-slate-600 hover:bg-slate-50 hover:text-primary-600'
                                    }`}
                            >
                                <span className={`transition-transform duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`}>
                                    {item.icon}
                                </span>
                                <span className="font-medium text-sm">
                                    {item.label}
                                </span>
                                {isActive && (
                                    <div className="ml-auto w-1.5 h-1.5 rounded-full bg-white animate-pulse"></div>
                                )}
                            </button>
                        );
                    })}
                </nav>

                {/* Footer */}
                <div className="p-4 border-t border-slate-100/50">
                    <button
                        onClick={handleSignOut}
                        className="w-full flex items-center gap-3 px-4 py-3 rounded-xl border border-red-100 text-red-500 hover:bg-red-50 hover:border-red-200 transition-all duration-300 group"
                    >
                        <LogoutIcon className="group-hover:-translate-x-1 transition-transform" />
                        <span className="font-medium text-sm">Cerrar Sesión</span>
                    </button>
                </div>
            </div>
        </aside>
    );
}
